import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {EvBatteryPerformanceStatus} from '@di-shared/features/home/kr/ev-battery/monitor/const';
import EvBatteryPerformaceBottomSheet from '@di-shared/features/home/kr/ev-battery/monitor/EvBatteryPerformaceBottomSheet';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 300;

function EvBatteryPerformaceBottomSheetPage() {
  const {t} = useInferableTranslation();
  const evBatteryPerformanceStatus = window.data.evBatteryPerformanceStatus as unknown as EvBatteryPerformanceStatus;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <EvBatteryPerformaceBottomSheet
        brandName={t('T30471')}
        evBatteryPerformanceStatus={evBatteryPerformanceStatus}
        onExit={() => window.bottomSheetClose(null)}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default EvBatteryPerformaceBottomSheetPage;
